<!-- components/FieldError.vue -->
<template>
    <div
      v-if="message"
      class="text-red-500 text-sm mb-3 flex items-center space-x-2 mt-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5 flex-shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="m4.9 4.9 14.2 14.2" />
      </svg>
  
      <p class="text-sm font-medium">{{ message }}</p>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      message: {
        type: String,
        default: ''
      }
    }
  }
  </script>
  